/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterThirdPartyNetworkAddPost } from '../fn/third-party-network/api-master-third-party-network-add-post';
import { ApiMasterThirdPartyNetworkAddPost$Params } from '../fn/third-party-network/api-master-third-party-network-add-post';
import { apiMasterThirdPartyNetworkDeleteGet } from '../fn/third-party-network/api-master-third-party-network-delete-get';
import { ApiMasterThirdPartyNetworkDeleteGet$Params } from '../fn/third-party-network/api-master-third-party-network-delete-get';
import { apiMasterThirdPartyNetworkEditPost } from '../fn/third-party-network/api-master-third-party-network-edit-post';
import { ApiMasterThirdPartyNetworkEditPost$Params } from '../fn/third-party-network/api-master-third-party-network-edit-post';
import { apiMasterThirdPartyNetworkGetActiveGet } from '../fn/third-party-network/api-master-third-party-network-get-active-get';
import { ApiMasterThirdPartyNetworkGetActiveGet$Params } from '../fn/third-party-network/api-master-third-party-network-get-active-get';
import { apiMasterThirdPartyNetworkGetAllGet } from '../fn/third-party-network/api-master-third-party-network-get-all-get';
import { ApiMasterThirdPartyNetworkGetAllGet$Params } from '../fn/third-party-network/api-master-third-party-network-get-all-get';
import { apiMasterThirdPartyNetworkGetByCriteriaPost } from '../fn/third-party-network/api-master-third-party-network-get-by-criteria-post';
import { ApiMasterThirdPartyNetworkGetByCriteriaPost$Params } from '../fn/third-party-network/api-master-third-party-network-get-by-criteria-post';
import { apiMasterThirdPartyNetworkGetPublishedGet } from '../fn/third-party-network/api-master-third-party-network-get-published-get';
import { ApiMasterThirdPartyNetworkGetPublishedGet$Params } from '../fn/third-party-network/api-master-third-party-network-get-published-get';
import { StringApiRespModel } from '../models/string-api-resp-model';
import { ThirdPartyNetwork } from '../models/third-party-network';
import { ThirdPartyNetworkApiRespModel } from '../models/third-party-network-api-resp-model';

@Injectable({ providedIn: 'root' })
export class ThirdPartyNetworkService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterThirdPartyNetworkAddPost()` */
  static readonly ApiMasterThirdPartyNetworkAddPostPath = '/api/Master/ThirdPartyNetwork/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterThirdPartyNetworkAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterThirdPartyNetworkAddPost$Response(params?: ApiMasterThirdPartyNetworkAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ThirdPartyNetworkApiRespModel>> {
    return apiMasterThirdPartyNetworkAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterThirdPartyNetworkAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterThirdPartyNetworkAddPost(params?: ApiMasterThirdPartyNetworkAddPost$Params, context?: HttpContext): Observable<ThirdPartyNetworkApiRespModel> {
    return this.apiMasterThirdPartyNetworkAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ThirdPartyNetworkApiRespModel>): ThirdPartyNetworkApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterThirdPartyNetworkEditPost()` */
  static readonly ApiMasterThirdPartyNetworkEditPostPath = '/api/Master/ThirdPartyNetwork/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterThirdPartyNetworkEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterThirdPartyNetworkEditPost$Response(params?: ApiMasterThirdPartyNetworkEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ThirdPartyNetworkApiRespModel>> {
    return apiMasterThirdPartyNetworkEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterThirdPartyNetworkEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterThirdPartyNetworkEditPost(params?: ApiMasterThirdPartyNetworkEditPost$Params, context?: HttpContext): Observable<ThirdPartyNetworkApiRespModel> {
    return this.apiMasterThirdPartyNetworkEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ThirdPartyNetworkApiRespModel>): ThirdPartyNetworkApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterThirdPartyNetworkDeleteGet()` */
  static readonly ApiMasterThirdPartyNetworkDeleteGetPath = '/api/Master/ThirdPartyNetwork/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterThirdPartyNetworkDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterThirdPartyNetworkDeleteGet$Response(params?: ApiMasterThirdPartyNetworkDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterThirdPartyNetworkDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterThirdPartyNetworkDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterThirdPartyNetworkDeleteGet(params?: ApiMasterThirdPartyNetworkDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterThirdPartyNetworkDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterThirdPartyNetworkGetAllGet()` */
  static readonly ApiMasterThirdPartyNetworkGetAllGetPath = '/api/Master/ThirdPartyNetwork/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterThirdPartyNetworkGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterThirdPartyNetworkGetAllGet$Response(params?: ApiMasterThirdPartyNetworkGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ThirdPartyNetwork>>> {
    return apiMasterThirdPartyNetworkGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterThirdPartyNetworkGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterThirdPartyNetworkGetAllGet(params?: ApiMasterThirdPartyNetworkGetAllGet$Params, context?: HttpContext): Observable<Array<ThirdPartyNetwork>> {
    return this.apiMasterThirdPartyNetworkGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ThirdPartyNetwork>>): Array<ThirdPartyNetwork> => r.body)
    );
  }

  /** Path part for operation `apiMasterThirdPartyNetworkGetActiveGet()` */
  static readonly ApiMasterThirdPartyNetworkGetActiveGetPath = '/api/Master/ThirdPartyNetwork/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterThirdPartyNetworkGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterThirdPartyNetworkGetActiveGet$Response(params?: ApiMasterThirdPartyNetworkGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ThirdPartyNetwork>>> {
    return apiMasterThirdPartyNetworkGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterThirdPartyNetworkGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterThirdPartyNetworkGetActiveGet(params?: ApiMasterThirdPartyNetworkGetActiveGet$Params, context?: HttpContext): Observable<Array<ThirdPartyNetwork>> {
    return this.apiMasterThirdPartyNetworkGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ThirdPartyNetwork>>): Array<ThirdPartyNetwork> => r.body)
    );
  }

  /** Path part for operation `apiMasterThirdPartyNetworkGetPublishedGet()` */
  static readonly ApiMasterThirdPartyNetworkGetPublishedGetPath = '/api/Master/ThirdPartyNetwork/GetPublished';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterThirdPartyNetworkGetPublishedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterThirdPartyNetworkGetPublishedGet$Response(params?: ApiMasterThirdPartyNetworkGetPublishedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ThirdPartyNetwork>>> {
    return apiMasterThirdPartyNetworkGetPublishedGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterThirdPartyNetworkGetPublishedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterThirdPartyNetworkGetPublishedGet(params?: ApiMasterThirdPartyNetworkGetPublishedGet$Params, context?: HttpContext): Observable<Array<ThirdPartyNetwork>> {
    return this.apiMasterThirdPartyNetworkGetPublishedGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ThirdPartyNetwork>>): Array<ThirdPartyNetwork> => r.body)
    );
  }

  /** Path part for operation `apiMasterThirdPartyNetworkGetByCriteriaPost()` */
  static readonly ApiMasterThirdPartyNetworkGetByCriteriaPostPath = '/api/Master/ThirdPartyNetwork/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterThirdPartyNetworkGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterThirdPartyNetworkGetByCriteriaPost$Response(params?: ApiMasterThirdPartyNetworkGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ThirdPartyNetwork>>> {
    return apiMasterThirdPartyNetworkGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterThirdPartyNetworkGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterThirdPartyNetworkGetByCriteriaPost(params?: ApiMasterThirdPartyNetworkGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<ThirdPartyNetwork>> {
    return this.apiMasterThirdPartyNetworkGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ThirdPartyNetwork>>): Array<ThirdPartyNetwork> => r.body)
    );
  }

}
